import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()

export class EmergencyService {

    showEmergencyTitle: BehaviorSubject<boolean>;

    constructor() {
      const isEmergency = JSON.parse(sessionStorage.getItem('isEmergencyLogin'));
      this.showEmergencyTitle = new BehaviorSubject<boolean>(isEmergency);
    }

    show() {
        this.showEmergencyTitle.next(true);
    }

    hide() {
        this.showEmergencyTitle.next(false);
    }

    // set isEmergencyLogin to true in sessionStorage
    setEmergencyState(): any {
        this.show();
        return sessionStorage.setItem('isEmergencyLogin', JSON.stringify(true));
    }

    // get isEmergencyLogin into manage-grid and app-main to hide menu tabs and buyPack button in certficates/manage on emergencyLogin
    getEmergencyState(): boolean {
        return JSON.parse(sessionStorage.getItem('isEmergencyLogin'));
    }

    // set isEmergencyLogin to false in auth/effects in log-out
    clearEmergencyState() {
        this.hide();
        return sessionStorage.setItem('isEmergencyLogin', JSON.stringify(false));
    }
}
